<template>
  <div>
    Unable to load component
  </div>
</template>

<script>
export default {
  name: 'default-error'
}
</script>

<style scoped>

</style>
